<script lang="ts">
  import HowToPlay from './HowToPlay.svelte';

  let { label = 'How to play', cls = '', backLabel = '← Back', size = 'normal' }: { label?: string; cls?: string; backLabel?: string; size?: 'normal' | 'small' } = $props();
  let open = $state(false);
</script>

<button type="button" class="howto-link {cls}" class:small={size === 'small'} onclick={() => (open = true)}>{label}</button>
{#if open}<HowToPlay {backLabel} onclose={() => (open = false)} />{/if}

<style>
  .howto-link {
    font: inherit; font-weight: 800; color: var(--cyan); cursor: pointer; padding: 0.4em 1.2em;
    border-radius: 999px; background: rgba(125, 249, 255, 0.08); border: 2px solid rgba(125, 249, 255, 0.5);
  }
  .howto-link.small {
    font-weight: 700; font-size: clamp(0.9rem, 1.15vw, 1.1rem); padding: 0.35em 0.9em; color: rgba(255, 255, 255, 0.8);
    background: transparent; border: 1.5px solid rgba(255, 255, 255, 0.28);
  }
  .howto-link.small:hover, .howto-link.small:focus-visible { color: var(--cyan); border-color: rgba(125, 249, 255, 0.7); }
  .howto-link:hover { box-shadow: 0 0 14px rgba(125, 249, 255, 0.5); }
</style>
